import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface CreateMiniTournamentPayload {
  meetingId: string;
  occurenceId: string;
  batchType?: string;
  timeControl?: string;
  rounds?: number;
}

export interface CreateMiniTournamentResponse {
  success: boolean;
  tournament_id?: number;
  name?: string;
  start_date?: string;
  end_date?: string;
  students_notified?: number;
  error?: string;
}

export default function useCreateMiniTournamentApi(
  handleOnSuccess?: (data: CreateMiniTournamentResponse) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<
  CreateMiniTournamentResponse,
  unknown,
  CreateMiniTournamentPayload
> {
  return useMutation<
    CreateMiniTournamentResponse,
    unknown,
    CreateMiniTournamentPayload
  >(
    async (payload: CreateMiniTournamentPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/create_mini_tournament/',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: (data: CreateMiniTournamentResponse) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to create mini tournament:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
